import { Link } from 'react-router-dom';
import portfolioData from '../../../data/portfolio-data';

const PortfolioTwo = () => {
    const portfolioItem = portfolioData.slice(0, 4);
    return (
        <div className="portfolio__two">
        </div>
    );
};

export default PortfolioTwo;